import React from 'react';
import { useSilentRefresh } from '../../hooks/auth/useSilentRefresh';

/**
 * Component that automatically refreshes user session in the background.
 * Uses the useSilentRefresh hook for all business logic.
 * This component doesn't render anything visible.
 */
export const SilentRefresh: React.FC = () => {
  // All logic is now in the hook - component is pure presentation (which is "nothing" in this case)
  useSilentRefresh();

  return null;
};
